(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zj-size-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
  const cups=['AA','A','B','C','D','DD','E','F','FF','G','GG','H','HH'];
  const clamp=(v,min,max)=>Math.min(Math.max(v,min),max);
  const nearestEven=(v)=>Math.round(v/2)*2;

  function init(root){
    if(!root || root.dataset.zjReady==='true') return;
    root.dataset.zjReady='true';
    let unit='in';
    let step=1;
    const under=root.querySelector('[data-underbust]');
    const bust=root.querySelector('[data-bust]');
    const result=root.querySelector('[data-result]');
    const progress=root.querySelector('[data-progress-fill]');

    function convertInput(input,to){
      const v=parseFloat(input.value);
      if(!Number.isFinite(v)) return;
      input.value=to==='cm'?(v*2.54).toFixed(1):(v/2.54).toFixed(1);
    }

    function setUnit(next){
      if(next===unit) return;
      convertInput(under,next);
      convertInput(bust,next);
      unit=next;
      root.querySelectorAll('[data-unit]').forEach(btn=>{
        const active=btn.dataset.unit===unit;
        btn.classList.toggle('is-active',active);
        btn.setAttribute('aria-pressed',String(active));
      });
      root.querySelectorAll('[data-unit-label]').forEach(el=>el.textContent=unit==='cm'?'cm':'in');
    }

    function clearErrors(){root.querySelectorAll('[data-error]').forEach(el=>el.textContent='');}
    function inches(v){return unit==='cm'?v/2.54:v;}

    function validate(which){
      clearErrors();
      const u=parseFloat(under.value);
      const b=parseFloat(bust.value);
      if(which==='underbust' || which==='all'){
        if(!Number.isFinite(u) || u<=0){root.querySelector('[data-error="underbust"]').textContent='Enter your underbust measurement to continue.';under.focus();return false;}
        const ui=inches(u);
        if(ui<24 || ui>50){root.querySelector('[data-error="underbust"]').textContent='That looks unusual. Please re-check the tape position and measurement.';under.focus();return false;}
      }
      if(which==='bust' || which==='all'){
        if(!Number.isFinite(b) || b<=0){root.querySelector('[data-error="bust"]').textContent='Enter your full-bust measurement to continue.';bust.focus();return false;}
        const bi=inches(b);
        if(bi<26 || bi>65){root.querySelector('[data-error="bust"]').textContent='That looks unusual. Please re-check the fullest-point measurement.';bust.focus();return false;}
        if(Number.isFinite(u) && inches(b)<=inches(u)){root.querySelector('[data-error="bust"]').textContent='Your bust measurement should be larger than your underbust. Please measure again.';bust.focus();return false;}
      }
      return true;
    }

    function showStep(next){
      step=next;
      result.hidden=true;
      root.querySelectorAll('[data-step-panel]').forEach(panel=>{
        const active=Number(panel.dataset.stepPanel)===step;
        panel.hidden=!active;
        panel.classList.toggle('is-active',active);
      });
      root.querySelectorAll('[data-step-label]').forEach(label=>label.classList.toggle('is-active',Number(label.dataset.stepLabel)<=step));
      progress.style.width=(step/3*100)+'%';
      const panel=root.querySelector('[data-step-panel="'+step+'"]');
      if(panel) panel.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
    }

    function cupFor(diff){
      if(diff<=0) return 'AA';
      if(diff>=cups.length) return cups[cups.length-1]+'+';
      return cups[diff];
    }

    function sisterCup(diff,delta){
      const idx=clamp(diff+delta,0,cups.length-1);
      return cups[idx];
    }

    function calculate(){
      if(!validate('all')) return;
      const underIn=inches(parseFloat(under.value));
      const bustIn=inches(parseFloat(bust.value));
      const roundedUnder=Math.round(underIn);
      const band=clamp(nearestEven(roundedUnder),28,48);
      const diff=clamp(Math.round(bustIn-roundedUnder),0,13);
      const cup=cupFor(diff);
      const size=band+cup;
      const lowerBand=band>28?(band-2)+sisterCup(diff,1):'—';
      const upperBand=band<48?(band+2)+sisterCup(diff,-1):'—';
      const fit=(root.querySelector('input[name^="zj-fit-"]:checked')||{}).value||'balanced';
      const fitNote=fit==='snug'?'You prefer a firmer feel, so the lower-band sister size may be useful if you are between bands.':fit==='relaxed'?'You prefer more room, so the upper-band sister size may be useful if you are between bands.':'Start here, then use the sister sizes only if the band feels noticeably too firm or too relaxed.';

      root.querySelector('[data-result-size]').textContent=size;
      root.querySelector('[data-result-band]').textContent=band;
      root.querySelector('[data-result-cup]').textContent=cup;
      root.querySelector('[data-sister-down]').textContent=lowerBand;
      root.querySelector('[data-sister-up]').textContent=upperBand;
      root.querySelector('[data-result-text]').textContent='Estimated from your two measurements. '+fitNote;
      root.querySelectorAll('[data-step-panel]').forEach(p=>p.hidden=true);
      result.hidden=false;
      progress.style.width='100%';
      result.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
    }

    root.addEventListener('click',e=>{
      const unitBtn=e.target.closest('[data-unit]');
      if(unitBtn){setUnit(unitBtn.dataset.unit);return;}
      const next=e.target.closest('[data-next-step]');
      if(next){const ok=step===1?validate('underbust'):validate('bust');if(ok) showStep(Number(next.dataset.nextStep));return;}
      const prev=e.target.closest('[data-prev-step]');
      if(prev){showStep(Number(prev.dataset.prevStep));return;}
      if(e.target.closest('[data-calculate]')){calculate();return;}
      if(e.target.closest('[data-restart]')){under.value='';bust.value='';clearErrors();showStep(1);under.focus();}
    });

    const reveals=root.querySelectorAll('.zj-sg-reveal');
    if('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target);}}),{threshold:.12});
      reveals.forEach(el=>io.observe(el));
    }else{reveals.forEach(el=>el.classList.add('is-visible'));}
  }

  function initAll(ctx){(ctx||document).querySelectorAll('[data-zj-size-guide]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initAll(document)); else initAll(document);
  document.addEventListener('shopify:section:load',e=>initAll(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
